import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;

  & > * {
    &:not(:first-child) {
      margin-left: 10px;
    }
  }
`;

export default ButtonGroup;
